import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:8000',
  headers: {
    'Content-Type': 'application/json',
  },
});

export const voteForNomination = (nominationId) => {
  return api.post(`/api/nominations/${nominationId}/vote/`);
};

export const removeVoteFromNomination = (nominationId) => {
  return api.delete(`/api/nominations/${nominationId}/vote/`);
};

export default api;